import React, { useEffect, useState, useRef } from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
} from "../recoil-atom"

import { authService, dbService } from "../fbase"
import {
  collection,
  query,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  onSnapshot,
  writeBatch,
} from "firebase/firestore"

import Notice from "../components/Notice"

import {
  Flex,
  FlexColumn,
  Input,
  Textarea,
  Submit,
  DivRound,
} from "../styled-components-openmark"
// import styled from "styled-components"

import { AddCircle } from "@styled-icons/ionicons-solid"
import { MinusCircle } from "@styled-icons/evaicons-solid"

const Profile = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [updatedProfileObj, setUpdatedProfileObj] = useRecoilState(
    updatedProfileObjState
  )
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [newMemo, setNewMemo] = useState("")
  const [review, setReview] = useState("")

  useEffect(() => {
    setUpdatedProfileObj(profileObj)
  }, [])

  const onChange = (event) => {
    const {
      target: { name, value },
    } = event

    if (name === "displayName") {
      setUpdatedProfileObj({ ...updatedProfileObj, displayName: value })
    } else if (name === "info") {
      setUpdatedProfileObj({ ...updatedProfileObj, info: value })
    }
  }

  // Textarea Resize
  const memo = useRef()
  useEffect(() => {
    if (memo.current) {
      memo.current.style.height = "auto"
      memo.current.style.height = `${memo.current.scrollHeight}px`
    }
  }, [newMemo])
  const reviewRef = useRef()
  useEffect(() => {
    if (reviewRef.current) {
      reviewRef.current.style.height = "auto"
      reviewRef.current.style.height = `${reviewRef.current.scrollHeight}px`
    }
  }, [review])

  const onEnterPress = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        setNewMemo(event.target.value)
        console.log(newMemo)
      } else {
        addMemo()
      }
    }
  }

  const addMemo = () => {
    const now = new Date()
    const nowYMDHM = `[${now.getFullYear()}/${(now.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${now.getDate().toString().padStart(2, "0")} ${now
      .getHours()
      .toString()
      .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}] `

    const newMemos = [...updatedProfileObj.memos]
    newMemos.unshift(nowYMDHM + newMemo)
    setUpdatedProfileObj({ ...updatedProfileObj, memos: newMemos })
    setTimeout(() => {
      setNewMemo("")
    }, 1)
  }

  const deleteMemo = (index) => {
    const newMemos = [...updatedProfileObj.memos]
    newMemos.splice(index, 1)
    setUpdatedProfileObj({ ...updatedProfileObj, memos: newMemos })
  }

  const saveProfile = async () => {
    const now = new Date().getTime()
    const newUserObj = {
      ...userObj,
      displayName: updatedProfileObj.displayName,
      info: updatedProfileObj.info,
      search: updatedProfileObj.search,
      memos: updatedProfileObj.memos,
      colors: updatedProfileObj.colors,
      updatedAt: now,
    }
    setUserObj(newUserObj)
    window.localStorage.setItem("user", JSON.stringify(newUserObj))

    // Get a new write batch
    const batch = writeBatch(dbService)

    // Update the population of editedPages
    const userRef = doc(dbService, "users", userObj.uid)
    batch.update(userRef, newUserObj)

    // Commit the batch
    await batch.commit()
  }

  // Send Review
  const sendReview = () => {
    const WEBAPP_URL =
      "https://script.google.com/macros/s/AKfycbyi8KISQHiFXmIJqvGolkrKdMiESwMo-AOaI1HqW9NJffKUPQjX_X0NVlRIWBSLnCg4-A/exec"
    const formData = new FormData()
    formData.append("Email", userObj.email)
    formData.append("Review", review)

    fetch(WEBAPP_URL, {
      method: "POST",
      body: formData,
    })
      .then((response) => console.log("Success!", response))
      .catch((error) => console.error("Error!", error.message))
    setReview("")
    alert("감사합니다")
  }

  return (
    <>
      {editMode && (
        <Notice notice={<>{shortName}님, openmark 저장 전입니다</>} />
      )}
      {!editMode &&
        JSON.stringify(updatedProfileObj) !== JSON.stringify(profileObj) && (
          <Notice notice={<>프로필 수정 후, 저장이 필요합니다</>} />
        )}
      {!editMode &&
        JSON.stringify(updatedProfileObj) === JSON.stringify(profileObj) && (
          <Notice notice={`${userObj.email} 님`} />
        )}

      <div className="profile-page">
        <div style={{ width: size.pageWidth, marginBottom: "10px" }}>
          <div className="profile-info">
            <label htmlFor="edit-displayname" className="profile-label">
              표시이름
            </label>
            <Input
              id="edit-displayname"
              name="displayName"
              value={updatedProfileObj?.displayName}
              onChange={onChange}
              width={size.pageWidth - 115}
              bgColor={
                updatedProfileObj?.colors
                  ? updatedProfileObj.colors.b0
                  : theme.b0
              }
              style={{
                border: `solid 1px ${
                  updatedProfileObj?.colors
                    ? updatedProfileObj.colors.b2
                    : theme.b2
                }`,
              }}
            />
            <label htmlFor="edit-info" className="profile-label">
              간단소개
            </label>
            <Input
              id="edit-info"
              name="info"
              value={updatedProfileObj?.info}
              onChange={onChange}
              width={size.pageWidth - 115}
              bgColor={
                updatedProfileObj?.colors
                  ? updatedProfileObj.colors.b0
                  : theme.b0
              }
              style={{
                border: `solid 1px ${
                  updatedProfileObj?.colors
                    ? updatedProfileObj.colors.b2
                    : theme.b2
                }`,
              }}
            />
            <div className="profile-label">검색선택</div>
            <div className="profile-search">
              <div
                className="profile-search-select"
                onClick={() =>
                  setUpdatedProfileObj({
                    ...updatedProfileObj,
                    search: "naver",
                  })
                }
                style={{
                  backgroundColor: `${
                    updatedProfileObj?.search === "naver"
                      ? "#04CE5C"
                      : updatedProfileObj?.colors?.b1
                  }`,
                  color: `${
                    updatedProfileObj?.search === "naver"
                      ? "white"
                      : updatedProfileObj?.colors?.f0
                  }`,
                }}
              >
                Naver
              </div>
              <div
                className="profile-search-select"
                onClick={() =>
                  setUpdatedProfileObj({
                    ...updatedProfileObj,
                    search: "google",
                  })
                }
                style={{
                  backgroundColor: `${
                    updatedProfileObj?.search === "google"
                      ? "#333"
                      : updatedProfileObj?.colors?.b1
                  }`,
                  color: `${
                    updatedProfileObj?.search === "google"
                      ? "white"
                      : updatedProfileObj?.colors?.f0
                  }`,
                }}
              >
                Google
              </div>
            </div>
            <div></div>
          </div>
          <DivRound
            onClick={saveProfile}
            width={size.pageWidth - 100}
            bgColor={
              JSON.stringify(updatedProfileObj) !== JSON.stringify(profileObj)
                ? updatedProfileObj?.colors?.f1
                : updatedProfileObj?.colors?.b2
            }
            color={
              updatedProfileObj?.colors
                ? updatedProfileObj?.colors.b0
                : theme.b0
            }
            style={{ cursor: "pointer", textAlign: "center" }}
          >
            저장
          </DivRound>
        </div>

        {userObj.email === "jacealan1@gmail.com" && (
          <div className="profile-memo">
            {updatedProfileObj?.memos && updatedProfileObj.memos.length < 10 ? (
              <div className="profile-memo-list">
                <div onClick={addMemo}>
                  <AddCircle size="20" color={updatedProfileObj.colors.f2} />
                </div>
                <Textarea
                  ref={memo}
                  rows={1}
                  placeholder="memo"
                  name="newMemo"
                  value={newMemo}
                  onChange={(event) => setNewMemo(event.target.value)}
                  onKeyDown={onEnterPress}
                  width={size.pageWidth - 53}
                /><div />
                <Flex right>
                  <div className="shift-enter">
                    Shift+Enter : 줄바꿈
                  </div>
                </Flex>
              </div>
            ) : null}
            {updatedProfileObj?.memos &&
              updatedProfileObj.memos?.map((memo, index) => (
                <div className="profile-memo-list">
                  <div onClick={() => deleteMemo(index)}>
                    <MinusCircle
                      size="20"
                      color={updatedProfileObj.colors.f2}
                    />
                  </div>
                  <div className="memo">{memo}</div>
                </div>
              ))}
          </div>
        )}

        <div className="profile-review">
          <Textarea
            ref={reviewRef}
            rows={1}
            placeholder="😳사용후기를 보내주세요🥳"
            name="review"
            value={review}
            onChange={(event) => setReview(event.target.value)}
            width={size.pageWidth - 40}
          />
          <Flex right>
            <div className="shift-enter">
              Shift+Enter : 줄바꿈
            </div>
          </Flex>
          <DivRound
            onClick={sendReview}
            width={size.pageWidth - 100}
            bgColor={updatedProfileObj?.colors?.f2}
            color={updatedProfileObj?.colors.b0}
            style={{ cursor: "pointer", textAlign: "center" }}
          >
            사용후기 보내기
          </DivRound>
        </div>
      </div>

      <style jsx>{`
        .profile-page {
          width: ${size.appWidth}px;
          margin: 10px auto 20px auto;
          border-radius: 20px;
          ${size.appPage === 2
            ? "padding: 20px 20px 20px 20px;"
            : "padding: 20px 0;"}
          background-color: ${updatedProfileObj
            ? updatedProfileObj?.colors?.b1
            : theme.b1};
          display: grid;
          grid-template-columns: repeat(${size.appPage}, 1fr);
          ${size.appPage === 2 ? "gap: 20px;" : "gap: 5px;"}
          box-shadow: 1px 1px 3px 1px ${updatedProfileObj
            ? updatedProfileObj?.colors?.b2
            : theme.b2};
        }

        .profile-info {
          width: ${size.pageWidth}px;
          height: 180px;
          margin-bottom: 10px;
          border-radius: 10px;
          padding: 10px;
          display: grid;
          grid-template-columns: 90px 1fr;
          align-items: center;
          background-color: ${updatedProfileObj
            ? updatedProfileObj?.colors?.b0
            : theme.b0};
          box-shadow: 1px 1px 3px 1px
            ${updatedProfileObj ? updatedProfileObj?.colors?.b2 : theme.b2};
        }

        .profile-label {
          width: 80px;
          margin: 5px 0px 5px 0;
          border-radius: 5px;
          padding: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          background-color: ${updatedProfileObj
            ? updatedProfileObj?.colors?.b1
            : theme.b1};
        }

        .profile-search {
          width: ${size.pageWidth - 100}px;
          margin-left: 3px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }

        .profile-search-select {
          text-align: center;
          cursor: pointer;
          width: ${size.pageWidth / 2 - 70}px;
          margin: 5px 0px 5px 0;
          border-radius: 5px;
          padding: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }

        .profile-memo {
          width: ${size.pageWidth}px;
          border-radius: 10px;
          /* margin: 5px 10px; */
          padding: 10px 0;
          background-color: ${updatedProfileObj
            ? updatedProfileObj.colors.b0
            : theme.b0};
          box-shadow: 1px 1px 3px 1px
            ${updatedProfileObj ? updatedProfileObj.colors.b2 : theme.b2};
          display: flex;
          flex-direction: column;
        }

        .profile-memo-list {
          /* height: 30px; */
          border-radius: 10px;
          margin: 5px 10px;
          background-color: ${updatedProfileObj
            ? updatedProfileObj.colors.b0
            : theme.b0};
          display: grid;
          grid-template-columns: 30px 1fr;
          /* justify-items: center; */
          align-items: start;
        }

        .memo {
          width: ${size.pageWidth - 60}px;
          user-select: text;
          background-color: ${updatedProfileObj
            ? updatedProfileObj.colors.b0
            : theme.b0};
          text-align: start;
          /* white-space: pre-line; */
          white-space: pre-wrap;
        }

        .profile-review {
          width: ${size.pageWidth}px;
          border-radius: 10px;
          /* margin: 5px 10px; */
          padding: 20px;
          background-color: ${updatedProfileObj
            ? updatedProfileObj.colors.b0
            : theme.b0};
          box-shadow: 1px 1px 3px 1px
            ${updatedProfileObj ? updatedProfileObj.colors.b2 : theme.b2};
          display: flex;
          flex-direction: column;
        }

        .shift-enter {
          font-size: 12px;
          color: ${theme.b2};
        }
      `}</style>
    </>
  )
}

export default Profile
